import React from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, FormControl, TextField } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import styles from './styles';

const SelectNameAutoComplete = (props) => {
  const { id, field, data = [], updateData, maxLength, closeCellAfterSelect } = props;
  const apiRef = useGridApiContext();
  const classes = styles();

  const [value, setValue] = React.useState('');
  const [inputValue, setInputValue] = React.useState('');

  React.useEffect(() => {
    setValue('');
    setInputValue('');
  }, [id]);

  const commitValue = (newValue) => {
    updateData(id, field, newValue ?? '');
    setValue(newValue ?? '');
    setInputValue(newValue ?? '');

    if (closeCellAfterSelect) {
      apiRef.current.setCellMode(id, field, 'view');
    }
  };

  return (
    <FormControl
      variant="filled"
      className={classes.inputField}
      sx={{ bgcolor: 'transparent' }}
    >
      <Autocomplete
        freeSolo
        disableClearable
        options={[...new Set(data)].sort()}
        value={value}
        inputValue={inputValue}
        onChange={(event, newValue) => {
          event.stopPropagation();
          commitValue(newValue);
        }}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        onBlur={() => commitValue(inputValue)}
        onKeyDown={(event) => {
          if (event.key === 'Tab') {
            event.preventDefault();
            commitValue(inputValue);
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            autoFocus
            variant="standard"
            label="Select or Enter"
            InputProps={{
              ...params.InputProps,
              disableUnderline: true
            }}
            inputProps={{
              ...params.inputProps,
              maxLength
            }}
          />
        )}
      />
    </FormControl>
  );
};

SelectNameAutoComplete.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  field: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.string),
  updateData: PropTypes.func.isRequired,
  closeCellAfterSelect: PropTypes.bool,
  maxLength: PropTypes.number
};

export default SelectNameAutoComplete;
